import axios from "../../../../../api/axios";
import { useEffect, useState } from "react";
import { useNavigate,Link } from "react-router-dom";
import {isEmpty} from '../../../../../Utilities/Utils'
import { useAuth } from "../../../../../ContextApp/AuthContext";
import './fichecss.css'
function Fiche(){
    const {user}=useAuth()
    const [eleves,setEleves]=useState([])
    const [classes,setClasses]=useState([])
    const [titulariat,setTitulariat]=useState([])
    const [cotes,setCotes]=useState([])
    const [ecole,setEcole]=useState([])
    const [cours,setCours]=useState([])
    const [evaluations,setEvaluations]=useState([])
    const [ponderation,setPonderation]=useState("")
    const [periode,setPeriode]=useState("")
    const navigate=useNavigate()
    const [detailcotes,setDetailcotes]=useState([])
    const [loading,setLoading]=useState(false)
    const [date_evaluations,setDate_evaluations]=useState()
    const [showFilters, setShowFilters] = useState(false);
    const [classe,setClasse]=useState("")
    const [cour,setCour]=useState("")
    const recordcours=cours.filter((cr)=>cr.idclasse==classe && cr.idenseignant==user?.ecole[0]?.idenseignant)
    const coursencours=cours.filter((cr)=>cr.id==cour)
    const recordevaluations=!isEmpty(periode) ? evaluations.filter((evaluation)=>evaluation.idclasse==classe && evaluation.idcour==cour && evaluation.periode==periode) : evaluations.filter((evaluation)=>evaluation.idclasse==classe && evaluation.idcour==cour)
    const recordseleves=eleves.filter((eleve)=>eleve.idclasse==classe)
    let total=0
    let totalmax=recordevaluations.reduce((sum, rec) => sum + parseInt(rec.ponderation || 0), 0)
    let summ=0
    let maximum=0
    const dateformate=(mydate)=>{
    const [year, month, day] = mydate.split('-');
    const formattedDate = `${day}/${month}`;
    
    return formattedDate
}
    
   
useEffect(()=>{
    HandleRequest()
    elevesrequest()
    coursRequest()
    handleallcotes()
    HandleClassesTitulariat()
},[])
const HandleRequest=async()=>{
    await axios.post('api/classes_getter',{idecole:user?.ecole[0]?.id}).then((res)=>{
        setClasses(res.data.items)
        setEcole(res.data.ecole)
    }).catch((err)=>{
        
    })
}
const coursRequest=async()=>{
    await axios.post('api/getcours',{idecole:user?.ecole[0]?.id,annee_scolaire:user?.programme_scolaire?.annee_scolaire}).then((res)=>{
        setCours(res.data.items)
    }).catch((err)=>{
        
    })
}
const HandleClassesTitulariat=async()=>{
    await axios.post(`api/getclassetitulariat/${user?.ecole[0]?.id}/${user?.ecole[0]?.idenseignant}`,{idecole:user?.ecole[0]?.id,annee_scolaire:user?.programme_scolaire?.annee_scolaire,idenseignant:user?.ecole[0]?.idenseignant}).then((res)=>{
        setTitulariat(res.data.items)
       
    }).catch((err)=>{})
}
const elevesrequest=async()=>{
    setLoading(true)
    await axios.post("api/allinscription",{idecole:user?.ecole[0]?.id,annee_scolaire:user?.programme_scolaire?.annee_scolaire}).then((res)=>{
        setEleves(res?.data?.items)
        setLoading(false)
    }).catch((err)=>{

    })
}
const handleallcotes=async()=>{
    await axios.post('api/getallcotes',{idecole:user?.ecole[0]?.id,annee_scolaire:user?.programme_scolaire?.annee_scolaire,idenseignant:user?.ecole[0]?.idenseignant}).then((res)=>{
        setCotes(res?.data?.items)
        setEvaluations(res?.data?.evaluations)
        setDetailcotes(res?.data?.detailcotes)
        
    }).catch((err)=>{

    })
}

const moyenne=(total,maximum,ponderation)=>{
    const pond=(periode=="Examen1" || periode=="Examen2") ? ponderation*2 : ponderation
    return parseInt(total/maximum*pond)
}
const somme=(point)=>{
   summ=summ+point
   return summ
}
const reinitialisation=()=>{
    summ=0
}
const maximumEval=()=>{
    recordevaluations?.length>0 &&
      recordevaluations.map((rec)=>
      {
          maximum=maximum+rec.ponderation
      }
      )
  return maximum
  }
  console.log(detailcotes)
  console.log(recordevaluations)
  console.log(totalmax)
  console.log(parseInt(coursencours?.[0]?.ponderation))
    return(
        
  <div className="container-fluid py-4 bg-light min-vh-100">
        <div className="row justify-content-center">
            <div className="col-11">
            <div className="d-flex justify-content-between align-items-center mb-2">
        <h5 className="mb-0 text-muted small fw-bold text-uppercase">Configurations</h5>
        <button 
            className="btn btn-sm btn-light border-0 shadow-sm" 
            onClick={() => setShowFilters(!showFilters)}
        >
            {showFilters ? (
                <span><i className="bi bi-chevron-up me-1"></i> Masquer les filtres</span>
            ) : (
                <span><i className="bi bi-filter me-1"></i> Afficher les filtres</span>
            )}
        </button>
      </div>   
            {/* --- Section Filtres --- */}
              <div className={`card border-0 shadow-sm mb-4 p-3 transition-collapse ${showFilters ? 'd-block' : 'd-none'}`}>           
                     <div className="row g-3">
                    <div className="col-md-4">
                        <label className="form-label fw-bold small">Classe</label>
                        <select className="form-select border-0 bg-light" onChange={(e)=>setClasse(e.target.value)} value={classe}>
                            <option value="">Sélectionner la classe</option>
                            {classes.map(clas => <option key={clas.id} value={clas.id}>{clas.nom}</option>)}
                        </select>
                    </div>
                    {/* Répétez le même style pour Cours et Période */}
                    <div className="col-md-4">
                      <label className="form-label fw-bold small">Cours</label>
                      <select className="form-select border-0 bg-light" onChange={(e)=>setCour(e.target.value)} value={cour}>
                        <option value="">Cours...</option>
                        {recordcours.map((cr)=><option key={cr.id} value={cr.id}>{cr.cours}</option>)}
                      </select>
                    </div>
                    <div className="col-md-4">
                      <label className="form-label fw-bold small">Période</label>
                      <select className="form-select border-0 bg-light" onChange={(e)=>setPeriode(e.target.value)} value={periode}>
                        <option value="">Période...</option>
                        <option value="P1">1ère Période</option>
                        <option value="P2">2ème Période</option>
                        <option value="Examen1">Examen S1</option>
                        <option value="P3">3ème Période</option>
                        <option value="P4">4ème Période</option>
                        <option value="Examen2">Examen S2</option>
                      </select>
                    </div>
                </div>
            </div>

            {/* --- Section Tableau --- */}
            <div className="table-card">
                <div className="table-responsive-custom">
                    <table className="custom-table">
                        <thead>
                            <tr>
                                <th className="sticky-id">#</th>
                                <th className="sticky-name">Élève</th>
                                {recordevaluations.map((evalu, i) => (
                                    <th key={i} className="text-center">
                                        <div className="text-muted mb-1" style={{fontSize:'10px'}}>{dateformate(evalu.date_evaluation)}</div>
                                        <div className="text-primary">Max: {evalu.ponderation}</div>
                                    </th>
                                ))}
                                <th className="text-center bg-light">Total ({maximumEval()})</th>
                                <th className="text-center bg-light">Moyenne ({coursencours?.[0]?.ponderation})</th>
                            </tr>
                        </thead>
                        <tbody>
                            {recordseleves.map((elev, index) => (
                                <tr key={index}>
                                    <td className="sticky-id text-muted">{index + 1}</td>
                                    <td className="sticky-name fw-semibold">{elev.nom_complet}</td>
                                    
                                    {recordevaluations.map((evaluation, j) => (
                                        <td key={j} className="text-center">
                                            {detailcotes.filter(d => d.idinscription === elev.id && d.idcour === Number(cour) && d.date_evaluation === evaluation.date_evaluation)
                                                .map(det =>(
                                                        <span className="points-badge" key={det.id}>{parseInt(det.point)}</span>
                                                        
                                                ) )
                                                
                                            }
                                        </td>
                                    ))}
                                    
                                    <td className="text-center total-cell">{detailcotes.filter(d => d.idinscription === elev.id && d.idcour === Number(cour)).reduce((sum, det) => sum + parseInt(det.point || 0), 0)}</td>
                                    <td className="text-center moyenne-cell">
                                        {!isEmpty(periode) && moyenne(parseInt(detailcotes.filter(d => d.idinscription === elev.id && d.idcour === Number(cour)).reduce((sum, det) => sum + parseInt(det.point || 0), 0)), parseInt(totalmax), parseInt(coursencours?.[0]?.ponderation))}
                                    </td>
                                    {reinitialisation()}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* --- Section Actions --- */}
            <div className="mt-4 d-flex gap-2">
                <Link to={`${classe}/${cour}/${periode}`} className="btn btn-primary px-4 shadow-sm">
                    <i className="bi bi-file-earmark-pdf me-2"></i> Télécharger la fiche
                </Link>
                {!isEmpty(titulariat) && (
                    <Link to={`/listeproclamation/${classe}/${periode}`} className="btn btn-outline-success px-4 shadow-sm">
                         Liste de proclamation
                    </Link>
                )}
            </div>

        </div>
    </div>
</div>


    )
}

export default Fiche;